import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './full-width-container.module.scss'

interface FullWidthContainerProps extends HTMLAttributes<HTMLDivElement> {
  background?: string
  desktopBackground?: string
  color?: string
}

export const FullWidthContainer: FC<FullWidthContainerProps> = ({
  background,
  desktopBackground,
  color,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(classes.fullWidthContainer, className)}
    style={
      {
        ...style,
        '--fwc-background': background,
        '--fwc-color': color || undefined,
        '--fwc-desktop-background': desktopBackground || undefined,
      } as React.CSSProperties
    }
    {...rest}
  >
    {children}
  </div>
)

export default FullWidthContainer
